import { MouseEvent } from "react";
import { IButtonMenuOption } from "../../button-menu/interfaces/IButtonMenuOption";
import { ButtonMenuRow } from "../../button-menu/ButtonMenuRow.component";
import { FloatingPanelMenuItemRenderer } from "../types/FloatingPanelMenuItemRenderer";

export const IconTextMenuItem: FloatingPanelMenuItemRenderer<IButtonMenuOption> = (model, item, itemIndex, menuId, onClick) => {
    const key = `${menuId}-${itemIndex}`;

    return (
        <ButtonMenuRow
            activeRow={itemIndex === model.activeItemIndex}
            id={`${menuId}-${itemIndex}`}
            option={item}
            key={key}
            onClick={(e: MouseEvent) => {
                onClick(e, itemIndex);
                item.onSelect();
            }}
        />
    );
};
